module.exports = "/_next/static/images/aa1c8e6d9ae4cb7f5327d5692f5da581-nubank-shooting-hands-diversity@1x.jpg.webp";